import { useEffect } from 'react';

import { LoadingSpinner, LoadingSpinnerSize } from '@/components/common';

import { UIBlockerProps } from './schemas';

export function UIBlockerContent({ blocked = false }: UIBlockerProps) {
  const trapFocus = (e: Event) => e.preventDefault();

  useEffect(() => {
    if (blocked) {
      document.addEventListener('keydown', trapFocus);
    } else {
      document.removeEventListener('keydown', trapFocus);
    }

    return () => document.removeEventListener('keydown', trapFocus);
  }, [blocked]);

  if (!blocked) {
    return null;
  }

  return (
    <div>
      <div className="fixed inset-0 z-50 overflow-hidden bg-secondary opacity-80"></div>
      <div className="fixed inset-0 z-60 cursor-not-allowed">
        <div className="flex flex-col justify-center h-full">
          <LoadingSpinner size={LoadingSpinnerSize.Small} />
        </div>
      </div>
    </div>
  );
}
